(function () {
  var ACTIVE_CLASS = "is-active";
  var LOCK_CLASS = "earlyup-cookie-lock";
  var BOOT_OPEN_CLASS = "earlyup-cookie-boot-open";
  var HAS_DECISION_CLASS = "earlyup-cookie-has-decision";
  var PRESSED_CLASS = "is-pressed";
  var SUBMITTING_CLASS = "is-submitting";
  var PRESS_CLEAR_DELAY = 180;
  var ROOT_SELECTOR = "[data-earlyup-cookie-root]";
  var OPEN_EVENT = "earlyup:cookie-banner:open";
  var PREFS_EVENT = "earlyup:cookie-banner:preferences";
  var FALLBACK_STORAGE_KEY = "earlyup_cookie_consent_fallback_v1";
  var FALLBACK_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
  var FALLBACK_WINDOW_NAME_PREFIX = "__earlyup_cookie_consent__:";
  var NATIVE_PANDECTES_SELECTORS = [
    "#pandectes-banner",
    "#pandectes-revoke-button",
    "#pandectes-reopen-button",
    ".cc-window-wrapper",
    ".pd-cookie-banner-window",
    "[id*='pandectes'][id*='banner']",
    "[id*='pandectes'][id*='reopen']",
    "[id*='pandectes'][id*='revoke']",
    "[class*='pandectes'][class*='banner']",
    "[class*='pandectes'][class*='widget']"
  ];

  function parseBoolean(value, fallback) {
    if (value === undefined || value === null || value === "") return fallback;
    return value === "true";
  }

  function splitHashes(value) {
    return (value || "#cookie-settings,#reopenBanner")
      .split(",")
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
  }

  function loadCustomerPrivacy() {
    return new Promise(function (resolve, reject) {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== "function") {
        reject(new Error("Shopify.loadFeatures is unavailable."));
        return;
      }

      var settled = false;
      var timeoutId = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        reject(new Error("Shopify customerPrivacy loading timed out."));
      }, 2500);

      window.Shopify.loadFeatures(
        [
          {
            name: "consent-tracking-api",
            version: "0.1"
          }
        ],
        function (error) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeoutId);

          if (error || !window.Shopify.customerPrivacy) {
            reject(error || new Error("Shopify customerPrivacy failed to load."));
            return;
          }

          resolve(window.Shopify.customerPrivacy);
        }
      );
    });
  }

  function getNativePandectesNodes() {
    return Array.prototype.slice.call(
      document.querySelectorAll(NATIVE_PANDECTES_SELECTORS.join(","))
    ).filter(function (node) {
      return !node.closest("[data-earlyup-cookie-root]");
    });
  }

  function hasNativePandectesBanner() {
    return !!document.querySelector("#pandectes-banner, .cc-window-wrapper, .pd-cookie-banner-window");
  }

  function hideNativePandectes(onBannerFound) {
    var hide = function () {
      var nodes = getNativePandectesNodes();

      nodes.forEach(function (node) {
        node.setAttribute("hidden", "");
        node.style.display = "none";
      });

      if (typeof onBannerFound === "function" && hasNativePandectesBanner()) {
        onBannerFound(nodes);
      }
    };

    hide();

    if (!("MutationObserver" in window)) return;

    var observer = new MutationObserver(hide);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(function () {
      observer.disconnect();
    }, 12000);
  }

  function currentConsentSnapshot(api) {
    if (!api || typeof api.currentVisitorConsent !== "function") return null;
    return api.currentVisitorConsent() || null;
  }

  function readFallbackConsent() {
    try {
      var raw = window.localStorage.getItem(FALLBACK_STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (error) {
    }

    try {
      if (typeof window.name === "string" && window.name.indexOf(FALLBACK_WINDOW_NAME_PREFIX) === 0) {
        return JSON.parse(window.name.slice(FALLBACK_WINDOW_NAME_PREFIX.length));
      }
    } catch (error) {
    }

    try {
      var cookieMatch = document.cookie.match(new RegExp("(?:^|; )" + FALLBACK_STORAGE_KEY + "=([^;]*)"));
      return cookieMatch ? JSON.parse(decodeURIComponent(cookieMatch[1])) : null;
    } catch (error) {
      return null;
    }
  }

  function writeFallbackConsent(payload) {
    try {
      window.localStorage.setItem(FALLBACK_STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
    }

    try {
      window.name = FALLBACK_WINDOW_NAME_PREFIX + JSON.stringify(payload);
    } catch (error) {
    }

    try {
      var serializedPayload = encodeURIComponent(JSON.stringify(payload));
      var secure = window.location.protocol === "https:" ? "; Secure" : "";
      document.cookie = FALLBACK_STORAGE_KEY + "=" + serializedPayload + "; Path=/; Max-Age=" + FALLBACK_COOKIE_MAX_AGE + "; SameSite=Lax" + secure;
    } catch (error) {
      return null;
    }
  }

  function clearFallbackConsent() {
    try {
      window.localStorage.removeItem(FALLBACK_STORAGE_KEY);
    } catch (error) {
    }

    try {
      if (typeof window.name === "string" && window.name.indexOf(FALLBACK_WINDOW_NAME_PREFIX) === 0) {
        window.name = "";
      }
    } catch (error) {
    }

    try {
      var secure = window.location.protocol === "https:" ? "; Secure" : "";
      document.cookie = FALLBACK_STORAGE_KEY + "=; Path=/; Max-Age=0; SameSite=Lax" + secure;
    } catch (error) {
      return null;
    }
  }

  function normalizeConsent(consent) {
    if (!consent) return null;

    return {
      preferences: consent.preferences === true || consent.preferences === "yes" ? "yes" : consent.preferences === false || consent.preferences === "no" ? "no" : "",
      analytics: consent.analytics === true || consent.analytics === "yes" ? "yes" : consent.analytics === false || consent.analytics === "no" ? "no" : "",
      marketing: consent.marketing === true || consent.marketing === "yes" ? "yes" : consent.marketing === false || consent.marketing === "no" ? "no" : ""
    };
  }

  function resolveConsent(api) {
    return normalizeConsent(currentConsentSnapshot(api)) || normalizeConsent(readFallbackConsent());
  }

  function consentHasDecision(consent) {
    consent = normalizeConsent(consent);
    if (!consent) return false;
    return ["yes", "no"].indexOf(consent.preferences) !== -1 ||
      ["yes", "no"].indexOf(consent.analytics) !== -1 ||
      ["yes", "no"].indexOf(consent.marketing) !== -1;
  }

  function setLoading(root, isLoading) {
    root.querySelectorAll("[data-cookie-action]").forEach(function (button) {
      button.disabled = isLoading;
      if (!isLoading) {
        button.classList.remove(PRESSED_CLASS, SUBMITTING_CLASS);
      }
    });
  }

  function setError(root, message) {
    var node = root.querySelector("[data-cookie-error]");
    if (!node) return;
    node.textContent = message || "";
    node.hidden = !message;
  }

  function shouldAutoOpen(root) {
    return parseBoolean(root.getAttribute("data-auto-open"), false);
  }

  function hasManualOpenRequest(root) {
    return root.__earlyupManualOpenRequested === true;
  }

  function setManualOpenRequest(root, isActive) {
    root.__earlyupManualOpenRequested = isActive === true;
  }

  function showPanel(root, panelName) {
    root.querySelectorAll("[data-cookie-panel]").forEach(function (panel) {
      panel.hidden = panel.getAttribute("data-cookie-panel") !== panelName;
    });
  }

  function setDocumentConsentState(options) {
    var docEl = document.documentElement;
    if (!docEl) return;

    if (options && options.bootOpen === true) {
      docEl.classList.add(BOOT_OPEN_CLASS);
    } else {
      docEl.classList.remove(BOOT_OPEN_CLASS);
    }

    if (options && options.hasDecision === true) {
      docEl.classList.add(HAS_DECISION_CLASS);
    } else {
      docEl.classList.remove(HAS_DECISION_CLASS);
    }
  }

  function positionDialog(root) {
    var dialog = root.querySelector("[data-cookie-dialog]");
    if (!dialog) return;

    var anchorSelector = root.getAttribute("data-anchor-selector");
    var homePath = root.getAttribute("data-home-path") || "/";
    var isHome = window.location.pathname === homePath;
    var anchor = anchorSelector ? document.querySelector(anchorSelector) : null;
    var mobileAnchor = document.querySelector("[data-earlyup-cookie-anchor-mobile], .earlyup-legal-overview__links");

    if (mobileAnchor && window.innerWidth < 750) {
      var mobileRect = mobileAnchor.getBoundingClientRect();
      if (mobileRect.width > 0 && mobileRect.height > 0) {
        var minTop = window.innerHeight * 0.78;
        var maxTop = window.innerHeight - 110;
        var targetTop = Math.min(Math.max(mobileRect.top + mobileRect.height * 0.82, minTop), maxTop);
        dialog.style.setProperty("--earlyup-cookie-left", "50%");
        dialog.style.setProperty("--earlyup-cookie-top", targetTop + "px");
        return;
      }
    }

    if (isHome && anchor && window.innerWidth >= 750) {
      var rect = anchor.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        dialog.style.setProperty("--earlyup-cookie-left", rect.left + rect.width / 2 + "px");
        dialog.style.setProperty("--earlyup-cookie-top", rect.top + rect.height / 2 + "px");
        return;
      }
    }

    dialog.style.setProperty("--earlyup-cookie-left", "50%");
    dialog.style.setProperty("--earlyup-cookie-top", "50%");
  }

  function syncPreferencesForm(root, consent) {
    var preferences = consent && consent.preferences === "yes";
    var analytics = consent && consent.analytics === "yes";
    var marketing = consent && consent.marketing === "yes";

    var preferencesInput = root.querySelector("[name='preferences']");
    var analyticsInput = root.querySelector("[name='analytics']");
    var marketingInput = root.querySelector("[name='marketing']");

    if (preferencesInput) preferencesInput.checked = !!preferences;
    if (analyticsInput) analyticsInput.checked = !!analytics;
    if (marketingInput) marketingInput.checked = !!marketing;
  }

  function clearPressedButtons(root) {
    if (!root) return;
    if (root.__earlyupCookiePressTimer) {
      window.clearTimeout(root.__earlyupCookiePressTimer);
      root.__earlyupCookiePressTimer = null;
    }

    root.querySelectorAll("[data-cookie-action]." + PRESSED_CLASS + ", [data-cookie-action]." + SUBMITTING_CLASS).forEach(function (button) {
      button.classList.remove(PRESSED_CLASS, SUBMITTING_CLASS);
    });
  }

  function schedulePressedButtonsClear(root) {
    if (!root) return;
    if (root.__earlyupCookiePressTimer) {
      window.clearTimeout(root.__earlyupCookiePressTimer);
    }

    root.__earlyupCookiePressTimer = window.setTimeout(function () {
      root.__earlyupCookiePressTimer = null;
      root.querySelectorAll("[data-cookie-action]." + PRESSED_CLASS).forEach(function (button) {
        if (!button.classList.contains(SUBMITTING_CLASS)) {
          button.classList.remove(PRESSED_CLASS);
        }
      });
    }, PRESS_CLEAR_DELAY);
  }

  function markPressedButton(root, button, isSubmitting) {
    if (!root || !button) return;

    if (root.__earlyupCookiePressTimer) {
      window.clearTimeout(root.__earlyupCookiePressTimer);
      root.__earlyupCookiePressTimer = null;
    }

    root.querySelectorAll("[data-cookie-action]." + PRESSED_CLASS + ", [data-cookie-action]." + SUBMITTING_CLASS).forEach(function (candidate) {
      if (candidate !== button) {
        candidate.classList.remove(PRESSED_CLASS, SUBMITTING_CLASS);
      }
    });

    button.classList.add(PRESSED_CLASS);

    if (isSubmitting) {
      button.classList.add(SUBMITTING_CLASS);
    } else {
      button.classList.remove(SUBMITTING_CLASS);
    }
  }

  function openBanner(root, panelName) {
    showPanel(root, panelName || "notice");
    positionDialog(root);
    setError(root, "");
    setDocumentConsentState({ bootOpen: true, hasDecision: false });
    root.classList.add(ACTIVE_CLASS);
    document.body.classList.add(LOCK_CLASS);
  }

  function closeBanner(root) {
    setManualOpenRequest(root, false);
    clearPressedButtons(root);
    setDocumentConsentState({ bootOpen: false, hasDecision: true });
    root.classList.remove(ACTIVE_CLASS);
    document.body.classList.remove(LOCK_CLASS);
  }

  function applyConsent(root, api, payload) {
    return new Promise(function (resolve, reject) {
      if (!api || typeof api.setTrackingConsent !== "function") {
        reject(new Error("Shopify customerPrivacy API is unavailable."));
        return;
      }

      writeFallbackConsent(payload);
      setLoading(root, true);
      setError(root, "");

      api.setTrackingConsent(payload, function () {
        setLoading(root, false);
        syncPreferencesForm(root, currentConsentSnapshot(api));
        document.dispatchEvent(new CustomEvent("earlyup:cookie-banner:consent-updated", {
          detail: payload
        }));
        resolve();
      });
    });
  }

  function bindHashTriggers(root, api) {
    var openHashes = splitHashes(root.getAttribute("data-open-hash"));

    var openFromHash = function () {
      if (openHashes.indexOf(window.location.hash) === -1) return;
      setManualOpenRequest(root, true);
      syncPreferencesForm(root, resolveConsent(api));
      openBanner(root, "notice");
    };

    document.addEventListener("click", function (event) {
      var trigger = event.target.closest("a[href]");
      if (!trigger) return;

      var href = trigger.getAttribute("href");
      if (openHashes.indexOf(href) === -1) return;

      event.preventDefault();
      history.replaceState(null, "", window.location.pathname + window.location.search + href);
      setManualOpenRequest(root, true);
      syncPreferencesForm(root, resolveConsent(api));
      openBanner(root, "notice");
    });

    window.addEventListener("hashchange", openFromHash);
    openFromHash();
  }

  function initRoot(root) {
    if (root.__earlyupCookieReady) return;
    root.__earlyupCookieReady = true;

    if (root.classList.contains(ACTIVE_CLASS)) {
      document.body.classList.add(LOCK_CLASS);
    }

    var nativeBannerTriggered = false;
    var mirrorNativeBanner = function () {
      if (nativeBannerTriggered) return;
      if (!shouldAutoOpen(root) && !hasManualOpenRequest(root)) return;
      nativeBannerTriggered = true;
      openBanner(root, "notice");
    };

    if (parseBoolean(root.getAttribute("data-hide-native-pandectes"), true)) {
      hideNativePandectes(mirrorNativeBanner);
    }

    var apiPromise = loadCustomerPrivacy().catch(function (error) {
      console.error("[EARLYUP Cookie Banner]", error);
      return null;
    });

    var noticeToggle = root.querySelector("[data-cookie-toggle]");
    var backButton = root.querySelector("[data-cookie-back]");
    var acceptButton = root.querySelector("[data-cookie-accept]");
    var rejectButton = root.querySelector("[data-cookie-reject]");
    var form = root.querySelector("[data-cookie-form]");

    root.addEventListener("pointerdown", function (event) {
      var button = event.target.closest("[data-cookie-action]");
      if (!button || !root.contains(button)) return;
      markPressedButton(root, button, false);
    });

    root.addEventListener("pointerup", function () {
      schedulePressedButtonsClear(root);
    });

    root.addEventListener("pointercancel", function () {
      schedulePressedButtonsClear(root);
    });

    if (noticeToggle) {
      noticeToggle.addEventListener("click", function () {
        showPanel(root, "preferences");
        positionDialog(root);
      });
    }

    if (backButton) {
      backButton.addEventListener("click", function () {
        showPanel(root, "notice");
        positionDialog(root);
      });
    }

    if (acceptButton) {
      acceptButton.addEventListener("click", function () {
        markPressedButton(root, acceptButton, true);
        apiPromise.then(function (api) {
          var payload = {
            preferences: true,
            analytics: true,
            marketing: true
          };

          if (!api) {
            writeFallbackConsent(payload);
            closeBanner(root);
            return;
          }

          applyConsent(root, api, payload).then(function () {
            closeBanner(root);
          }).catch(function (error) {
            console.error("[EARLYUP Cookie Banner]", error);
            setError(root, "Die Zustimmung konnte nicht gespeichert werden.");
            setLoading(root, false);
          });
        });
      });
    }

    if (rejectButton) {
      rejectButton.addEventListener("click", function () {
        markPressedButton(root, rejectButton, true);
        apiPromise.then(function (api) {
          var payload = {
            preferences: false,
            analytics: false,
            marketing: false
          };

          if (!api) {
            writeFallbackConsent(payload);
            closeBanner(root);
            return;
          }

          applyConsent(root, api, payload).then(function () {
            closeBanner(root);
          }).catch(function (error) {
            console.error("[EARLYUP Cookie Banner]", error);
            setError(root, "Die Ablehnung konnte nicht gespeichert werden.");
            setLoading(root, false);
          });
        });
      });
    }

    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        markPressedButton(root, event.submitter, true);

        apiPromise.then(function (api) {
          var formData = new FormData(form);
          var payload = {
            preferences: formData.get("preferences") === "on",
            analytics: formData.get("analytics") === "on",
            marketing: formData.get("marketing") === "on"
          };

          if (!api) {
            writeFallbackConsent(payload);
            closeBanner(root);
            return;
          }

          applyConsent(root, api, payload).then(function () {
            closeBanner(root);
          }).catch(function (error) {
            console.error("[EARLYUP Cookie Banner]", error);
            setError(root, "Die Auswahl konnte nicht gespeichert werden.");
            setLoading(root, false);
          });
        });
      });
    }

    apiPromise.then(function (api) {
      var knownConsent = resolveConsent(api);
      setDocumentConsentState({
        bootOpen: !consentHasDecision(knownConsent) && shouldAutoOpen(root),
        hasDecision: consentHasDecision(knownConsent)
      });
      syncPreferencesForm(root, knownConsent);
      bindHashTriggers(root, api);

      if (!api) {
        if (!consentHasDecision(knownConsent) && hasNativePandectesBanner()) {
          mirrorNativeBanner();
          if (shouldAutoOpen(root) || hasManualOpenRequest(root)) return;
        }

        if (hasManualOpenRequest(root)) {
          openBanner(root, "notice");
        } else if (!consentHasDecision(knownConsent) && shouldAutoOpen(root)) {
          openBanner(root, "notice");
        } else {
          closeBanner(root);
        }
        return;
      }

      if (!consentHasDecision(currentConsentSnapshot(api)) && consentHasDecision(readFallbackConsent())) {
        applyConsent(root, api, readFallbackConsent()).catch(function () {
          return null;
        });
      }

      if (hasManualOpenRequest(root)) {
        openBanner(root, "notice");
        return;
      }

      if (shouldAutoOpen(root) && typeof api.shouldShowBanner === "function" && api.shouldShowBanner()) {
        var consent = resolveConsent(api);
        if (!consentHasDecision(consent)) {
          openBanner(root, "notice");
          return;
        }
      }

      closeBanner(root);

      document.addEventListener("visitorConsentCollected", function () {
        syncPreferencesForm(root, resolveConsent(api));
        closeBanner(root);
      });
    });

    window.addEventListener("resize", function () {
      if (root.classList.contains(ACTIVE_CLASS)) positionDialog(root);
    });

    window.addEventListener("scroll", function () {
      if (root.classList.contains(ACTIVE_CLASS)) positionDialog(root);
    }, { passive: true });

    window.addEventListener(OPEN_EVENT, function () {
      apiPromise.then(function (api) {
        setManualOpenRequest(root, true);
        syncPreferencesForm(root, resolveConsent(api));
        openBanner(root, "notice");
      });
    });

    window.addEventListener(PREFS_EVENT, function () {
      apiPromise.then(function (api) {
        setManualOpenRequest(root, true);
        syncPreferencesForm(root, resolveConsent(api));
        openBanner(root, "preferences");
      });
    });
  }

  function boot() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);

    window.EarlyupCookieBanner = window.EarlyupCookieBanner || {
      open: function () {
        window.dispatchEvent(new Event(OPEN_EVENT));
      },
      openPreferences: function () {
        window.dispatchEvent(new Event(PREFS_EVENT));
      }
    };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
